// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__2VAxm","btn":"Nav_btn__fhVw3"};